export default __webpack_public_path__ + "static/media/import-icon.095526e6.svg";